export function repairMap() {
  return window.repairTorqoMap?.();
}
